import { createFileRoute } from '@tanstack/react-router'
import { SettingsPage } from '~/pages/settings/settings-page'

export const Route = createFileRoute('/settings/$tab')({
  component: RouteComponent,
})

function RouteComponent() {
  const { tab } = Route.useParams()
  return <SettingsPage tab={tab} />
}
